import type { Tag } from '@/modules/task/domain/tag/Tag';
import { TagType } from '@/modules/task/domain/tag/Tag';

export class UnansweredCallTag implements Tag {
  constructor(private readonly numberOfCalls: number) {}

  readonly type = TagType.UnansweredCall;

  get content(): string {
    return this.numberOfCalls.toString();
  }
}
